import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";
import DashboardDoughnut from "../DashboardDoughnut";
import DoughnutLegend from "../DoughnutLegend";
import HspOnsiteDecisionDialog from "./HspOnsiteDecisionDialog";

import { calculatePercentage } from "../../../utils/data";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  doughnutContainer: {
    margin: "0px 20px",
    display: "flex",
    alignItems: "center",
  },
};

const HspOnsiteDecision = (props) => {
  const { classes, data } = props;
  const [secondaryDetails, setSecondaryDetails] = React.useState({
    open: false,
    section: null,
    subSection: null,
  });

  const doughnutColors = [
    colors.greenDoughnut,
    colors.orangeAssistance,
    colors.errorRed,
  ];

  let filters = props.filters;
  if (get(filters, ["header"])) {
    filters.header.section = get(secondaryDetails, ["section"]);
    filters.header.subsection = get(secondaryDetails, ["subSection"]);
  }

  return (
    <DashboardCard
      title={I18n.get("dashboard_onsiteDecision")}
      size={sizes.small}
    >
      <HspOnsiteDecisionDialog
        open={get(secondaryDetails, ["open"])}
        setOpen={setSecondaryDetails}
        filters={filters}
        subSection={get(secondaryDetails, ["subSection"])}
      />
      <Grid container justify="center" alignItems="center">
        <Grid item className={classes.doughnutContainer}>
          <DashboardDoughnut
            values={[
              get(data, ["onsiteresults", "allowed", "total"]),
              get(data, ["onsiteresults", "assistance", "total"]),
              get(data, ["onsiteresults", "denied", "total"]),
            ]}
            total={
              get(data, ["onsiteresults", "allowed", "total"]) +
              get(data, ["onsiteresults", "assistance", "total"]) +
              get(data, ["onsiteresults", "denied", "total"])
            }
            colors={doughnutColors}
            onClick={() =>
              setSecondaryDetails({
                open: true,
                section: "onsitedecision",
                subSection: "all",
              })
            }
          />
        </Grid>
        <Grid
          item
          style={{ marginLeft: "10px", padding: "0px 14px", minWidth: "160px" }}
        >
          <Grid container direction="column">
            {map(["allowed", "assistance", "denied"], (type, index) => (
              <DoughnutLegend
                key={type}
                color={doughnutColors[index]}
                title={I18n.get(
                  `dashboard_${
                    type === "assistance" ? "requireAssistance" : type
                  }`
                )}
                value={get(data, ["onsiteresults", type, "total"])}
                percentage={calculatePercentage(
                  get(data, ["onsiteresults", type, "total"]),
                  get(data, ["onsiteresults", "allowed", "total"]) +
                    get(data, ["onsiteresults", "assistance", "total"]) +
                    get(data, ["onsiteresults", "denied", "total"])
                )}
                onClick={() =>
                  setSecondaryDetails({
                    open: true,
                    section: "onsitedecision",
                    subSection: type,
                  })
                }
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </DashboardCard>
  );
};

export default withStyles(styles)(HspOnsiteDecision);
